module.exports = __webpack_public_path__ + "static/media/apartment7.97fb7999.jpg";